import { render, staticRenderFns } from "./FooterComponentWrktp.vue?vue&type=template&id=57ce658a&scoped=true"
import script from "./FooterComponentWrktp.vue?vue&type=script&lang=ts"
export * from "./FooterComponentWrktp.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentWrktp.vue?vue&type=style&index=0&id=57ce658a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ce658a",
  null
  
)

export default component.exports